import React from 'react';

const LocationChartTooltip = ({ city, interactions, connections, deviceCount }) => {
    return <div className="location-chart-tooltip">
        <div className="location-chart-tooltip_city">{city}</div>
        <div className="location-chart-tooltip_sep" />
        <div className="location-chart-tooltip_interactions"><b>{interactions}</b> Voice Interactions</div>
        <div className="location-chart-tooltip_connections"><b>{connections}</b> Connections</div>
        <div className="location-chart-tooltip_sep" />
        <div className="location-chart-tooltip_users">{deviceCount} Users</div>
    </div>;
};

export default LocationChartTooltip;